
export class FacetAggregationField {
    public name: string;
    public displayName: string;
}